import React from 'react';
import SubHeader from '../../../layout/components/SubHeader';
import UserCard from './UserCard';
import './UserSettings.css';

function UserSettings() {
    return (
        <div className="ecx-page clinic-settings-page user-settings-page ecx-page--full-width">
            <SubHeader
                title="User Settings"
                description="Manage clinic users, roles, and account details"
                icon="bi-people"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <UserCard />
            </div>
        </div>
    );
}

export default UserSettings;
